export default class Employee {
    static CONTRACT_STATUS_INACTIVE = 0;
    static CONTRACT_STATUS_ACTIVE = 1;
    static CONTRACT_STATUS_SCHEDULED = 2;
    static CONTRACT_STATUS_LONG_TERM_ABSENCE = 4;

    static fromData(data) {
        if (!data) {
            return;
        }

        const employee = new Employee();
        employee.id = data.id;
        employee.firstName = data.firstName;
        employee.lastName = data.lastName;
        employee.fullName = data.fullName;
        employee.contractStatus = data.contractStatus;

        return employee;
    }
}
